// ─── Preview Draft Badge ──────────────────────────────────────
// Small, unobtrusive pill rendered on public invitation pages when
// the response represents an unpublished draft (?preview=TOKEN
// matched). Auto-fades to ~30% opacity after 5s and lives in the
// top-left corner so it never covers the language selector
// (top-right), hero content, or media. Hover to fully restore.
//
// Designers know at a glance "I'm looking at draft data".
// Guests never see this — the badge only mounts when `is_preview`
// is true and they don't have the preview token in their URL.

import React, { useEffect, useState } from 'react';

export default function PreviewDraftBadge() {
  const [faded, setFaded] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setFaded(true), 5000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={`fixed top-2 left-2 z-[200] px-1.5 py-0.5 rounded-full bg-violet-600/85 backdrop-blur-sm text-white text-[9px] font-semibold uppercase tracking-wider shadow-sm transition-opacity duration-700 select-none ${
        faded ? 'opacity-30 hover:opacity-100' : 'opacity-95'
      }`}
      data-testid="preview-draft-badge"
      aria-label="Preview draft mode"
      title="Preview · Draft — guests see the published snapshot"
    >
      <span className="inline-block w-1 h-1 rounded-full bg-white mr-1 align-middle" />
      Draft
    </div>
  );
}
